var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 28.6V12.3c0-1.2-.8-2-2-2H12.4c-1.2 0-2 .8-2 2v16.4c0 1.2.8 2 2 2h16.4c1-.2 1.8-.9 1.8-2.1m-4-2H14.4V14.3h12.4v12.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 5.4h12.4v1h4v-3c0-1.2-.8-2-2-2H3.4c-1.2 0-2 .8-2 2v16.4c0 1.2.8 2 2 2h3v-4h-1z"
  })));
};
export default SvgDuplicate;